import React from 'react';

import { SELECT_PLAN_SECTION_ID } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { SubscriptionButton } from '@/pages/Paywall/components/SubscriptionButton';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import { SubscriptionListStyles } from './Subscriptions.styles';

export const PaymentOnPageSubscriptions: React.FC<{
  isSuccess: boolean;
  isLoadingConfig: boolean;
  isCreatingSubscription: boolean;
  stripePlans: StripeV2SubscriptionPrice[] | null | undefined;
  theme?: 'dark-violet' | 'domination' | 'dark-forest' | null;
}> = ({
  isCreatingSubscription,
  isLoadingConfig,
  isSuccess,
  stripePlans,
  theme,
}) => {
  const { selectedPlanId } = useAccount();

  if (isLoadingConfig) {
    return (
      <SubscriptionListStyles id={SELECT_PLAN_SECTION_ID}>
        Loading...
      </SubscriptionListStyles>
    );
  }

  if (isSuccess) {
    return (
      <SubscriptionListStyles id={SELECT_PLAN_SECTION_ID}>
        {stripePlans?.map((plan) => {
          const selected = selectedPlanId === plan.id;

          return (
            <SubscriptionButton
              selected={selected}
              subscription={plan}
              key={plan.id}
              disabled={isCreatingSubscription}
              theme={theme}
            />
          );
        })}
      </SubscriptionListStyles>
    );
  }

  return (
    <SubscriptionListStyles id={SELECT_PLAN_SECTION_ID}>
      Error loading subscriptions
    </SubscriptionListStyles>
  );
};
